import React from "react";
import Text from "@ui/Text";
import type { rawFonts } from "@ui/Theme/fonts";
import type { BlockHeadingModelT } from "../../../../../schema/block/heading";

export const BlockHeading = React.memo(
  ({ block, className }: { block: BlockHeadingModelT; className?: string }) => {
    const level = `h${block.config.level}` as keyof typeof rawFonts;
    return (
      <Text type={level} className={className}>
        {block.data}
      </Text>
    );
  },
);
